// Unpublished Work © 2026 Deere & Company.

export const PRO_GOLF_HOME = 'PRO_GOLF_HOME';
export const TOOLS_COURSE_OPERATIONS = 'TOOLS_COURSE_OPERATIONS';
export const TOOLS_FLEET_MAINTENANCE = 'TOOLS_FLEET_MAINTENANCE';
export const TOOLS_FLEET_PARTS = 'TOOLS_FLEET_PARTS';
export const TOOLS_LABOR = 'TOOLS_LABOR';
export const TOOLS_GOLF = 'TOOLS_GOLF';
